module.exports = __webpack_public_path__ + "static/media/movie-coupon.07726ba0.png";